import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';

export type IndividualProducts = CommonColumns & {
  resourceName: string;
  licenseId: string;
  individualProductsId: string;
  title: string;
  price: string;
  availableDays: string;
  dayOfWeek: string;
  publishedAt: string;
  startsAt: string;
  endsAt: string;
  stripeProductId: string;
  stripePriceId: string;
  status: string;
};

// FIXME: refine
export const individualProducts: Readonly<IndividualProducts> = {
  ...commonColumns,
  ...{
    resourceName: '個人向け商品',
    licenseId: 'ライセンスID',
    individualProductsId: '商品ID',
    title: '商品名',
    price: '税込金額',
    availableDays: '期間(日数)',
    dayOfWeek: '曜日',
    startsAt: '開始日',
    endsAt: '終了日',
    publishedAt: '公開日時',
    stripeProductId: 'Stripe商品ID',
    stripePriceId: 'Stripe価格ID',
    status: 'ステータス',
  },
};

export const individualProductsDayOfWeeks: ReadonlyArray<number> = [
  0, 1, 2, 3, 4, 5, 6,
];

export const individualProductsDayOfWeeksName = (
  dayOfWeek: number | null
): string => {
  switch (dayOfWeek) {
    case 0:
      return '日曜日';
    case 1:
      return '月曜日';
    case 2:
      return '火曜日';
    case 3:
      return '水曜日';
    case 4:
      return '木曜日';
    case 5:
      return '金曜日';
    case 6:
      return '土曜日';
    default:
      return '未設定';
  }
};
